<div class="container-fluid">
  <footer class="footer">
    <div class="row align-items-center justify-content-xl-between">
      <div class="col-xl-6"></div>
      <div class="col-xl-6"></div>
    </div>
  </footer>
</div>
